/**
 * React Query hook for tenant info
 */

import { useQuery } from '@tanstack/react-query';
import { getTenantInfo } from '../api/tenantInfo';

export const tenantInfoKeys = {
  all: ['tenant-info'] as const,
  detail: () => [...tenantInfoKeys.all, 'detail'] as const,
};

export function useTenantInfo() {
  return useQuery({
    queryKey: tenantInfoKeys.detail(),
    queryFn: getTenantInfo,
  });
}
